import { CartResponse } from "../../initialize-cart/interface/initialize-cart.interface";
import { ShopCart } from "../interfaces/shop-cart.interface";

export const mapInitializeResponseToShopCart = (cartResponse: CartResponse) => {
  const shopResponse: ShopCart = {
    products: cartResponse?.products!,
    productCount: cartResponse?.productCount!,
    showPoOption: cartResponse?.showPoOption!,
    cartId: cartResponse?.cartId!,
    discount: cartResponse?.discount!,
    shippable: cartResponse?.shippable!,
    totalAmount: cartResponse?.totalAmount!,
    orderBusinessUnit: cartResponse?.orderBusinessUnit!,
    userBusinessUnit: cartResponse?.userBusinessUnit!,
    userRole: cartResponse?.userRole!,
    erpAccountNumber: cartResponse?.erpAccountNumber!,
    store: cartResponse?.store!,
    storeType: cartResponse?.storeType!,
    currencyCode: cartResponse.currencyCode!,
    intlTaxAmount: cartResponse?.intlTaxAmount!,
    isTunnelPurchase: cartResponse?.isTunnelPurchase!,
    errorMessage: cartResponse?.errorMessage!,
    availability: cartResponse?.availability!, 
    itemsCount: cartResponse.itemsCount!,
    storeName: cartResponse?.storeName!,
    guestCheckoutEmail: cartResponse?.guestCheckoutEmail!,
  } as ShopCart;

  return shopResponse;
};